module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente/motivosRechazo/motivosRechazo.component.html
// module id = ./src/app/cliente/motivosRechazo/motivosRechazo.component.html
// module chunks = main